export interface EstadoActivacionPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: EstadoActivacion[];
}

// orden_trabajo
export interface EstadoActivacion {
  id_estado_activacion: number;
  nombre: string;
  codigo: string;
}

/////* Orden de Trabajo
// ACTIVACION NO Upd estado OrdenTrabajo
export enum EstadoActivacionCodigoEnum {
  PENDIENTE = '1',
  GESTIONADA = '2', // sigue en espera orden_trabajo
  PENDIENTE_CAMBIO_DATOS = '3', // tecnico solicita cambio de puerto/nap

  PENDIENTE_HORA_FIN = '4', // tecnico sube OT
  REALIZADO_ACTIVACION = '5', // activacion setea hora inicio/fin y cierra OT
}



export enum EstadoOrdenTrabajoCodigoEnum {
  ESPERA = '1', // init state - Ok PyL

  // tecnico state like activacion state
  // PRE_REALIZADO = 2, // tecnico save orden_trabajo
  PRE_REALIZADO = '5', // tecnico save orden_trabajo - ahora cierra tecnico, ya No auditoria

  PRE_RECHAZADA = '3', // rechaza el tecnico

  ESPERA_RECOORDINADA = '6', // activacion recoordina > pasa a flujo normal - pre_realiado

  // PRE_REALIZADA_RECOORDINADA = 8,
  // REALIZADA_RECOORDINADA = 7, // new OW after RECOORDINADA

  // ACTIVACION recoordina
  RECHAZADA = '4', // rechazada validada activacion - rechazon final

  // ACTIVACION hora fin
  REALIZADO_ACTIVACION = '10', // activacion coloca hora fin y cierra ot

  // AUDITORIA setea estado Final REALIZADO | llegan PRE_REALIZADO
  RECHAZADO_AUDITORIA = '7', // tecnico must upd data - ya NO rechaza auditoria
  ESPERA_ACTUALIZACION = '8', // tecnico upd
  REALIZADO_ACTUALIZADO = '9', // auditoria aprueba OT after tecnico corrects

  REALIZADO = '5', // final cierra - ahora tecnico cierra, ya No auditoria
}



/////* Contratos: filtrar clientes basado en estado_contrato
export enum EstadoControatoCodigoEnum {
  ESPERA = "1", // ya no va como tab, solo para filtrar. Ok Auditoria cambia a ACTIVO
  ACTIVO = "2", // empiezan los tabs desde aqui
  SUSPENDIDO = "3",
  RETENCION = "4",
  RETIRADO = "5",
  ALL = "0",
}